import React, { useEffect, useMemo, useState } from 'react';
import Header from './component/Header';
import Navbar from './component/Navbar';
import axios from 'axios';
import ItemRow from './extra/ItemRow';
import Card from './extra/Card';
// import {Html5QrcodeScanner} from 'https://unpkg.com/html5-qrcode@2.3.8/html5-qrcode.min.js';

const PosCashier = () => {

    document.body.className = 'hold-transition sidebar-mini layout-fixed';

    const [list, setList] = useState([])
    const [list_category, setListCategory] = useState([])
    const [loopItem, setLoopItem] = useState([])

    const [selectedloopItem, setSelectedLoopItem] = useState({ _id: 0 })

    const loadProduct = async (event) => {
        axios.post("http://localhost:3001/product").then((res) => {
            console.log(res.data)
            setList(res.data)
            // if (res.data.username) {
            //     sessionStorage.setItem('username', res.data.username);
            //     window.location.assign("/pos/dashboard")
            // }
        })
            .catch((err) => {
                console.log(err);
            });
    }

    const loadCategory = async (event) => {
        axios.post("http://localhost:3001/category").then((res) => {
            console.log(res.data)
            setListCategory(res.data)
            // if (res.data.username) {
            //     sessionStorage.setItem('username', res.data.username);
            //     window.location.assign("/pos/dashboard")
            // }
        })
            .catch((err) => {
                console.log(err);
            });
    }

    const deletecLoop = (id) => {
        console.log(id)
        const data = loopItem.filter((i) => {
            return i !== id;
        });

        setLoopItem(data)
        setSelectedLoopItem({ _id: 0 })
    }


    const selecteUpdate = (item) => {
        let updatedList = loopItem.filter((i) => {
            return i._id == item._id;
        });
        
        const index = loopItem.findIndex((e) => e._id == item._id);
        if (updatedList.length > 0) {
            const index = loopItem.findIndex((e) => e._id == item._id);
            loopItem[index].qty += 1;
            setLoopItem([...loopItem])
        } else {
            setLoopItem([...loopItem, { ...item, qty: 1 }])
        }
    }




    const SubTotal = loopItem?.reduce((amount, item) => {
        var split1 = (item.price).split(',');
        var split2 = (split1[0]+''+split1[1])
        amount = (split2* item.qty) + amount
        return amount;
        console.log(amount)
    }, 0);


    useEffect(() => {
        loadProduct()
        loadCategory()
    }, [])


    return (
        
        <div style={{flex: 1}}>
            <div style={{flex: 3, display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <div style={{flex: 1, padding: 10}}>
                    <div style={{height: 500, backgroundColor: "#000"}}>
                        <table className='table table-bordered'>
                            <thead>
                                <tr>
                                    <td>QTY</td>
                                    <td>ITEM</td>
                                    <td>AMOUNT</td>
                                </tr>
                            </thead>
                            <tbody>

                            </tbody>
                        </table>
                    </div>
                    <div style={{height: 400, backgroundColor: "#ddd"}}>

                    </div>
                </div>
                <div style={{flex: 3}}>2</div>
            </div>
        </div>

    );
}

export default PosCashier;
